module.exports = __webpack_public_path__ + "img/ProductKV2.9b791c4d.webp";